import {Badge, Card, Col, List, message, Row} from "antd";
import flexCurrency from "../../utils/FlexCurrency";
import dayjs from "dayjs";
import {useEffect, useState} from "react";
import Api from "../../services/Api";
import axios from "axios";
import RestaurantComponent from "./components/restaurant/RestaurantComponent";
import HomeFotoKapanComponent from "./components/fotokapan/HomeFotoKapanComponent";
import HomeAracGecisComponent from "./components/aracgecis/HomeAracGecisComponent";
import GelirToplamComponent from "./components/GelirToplamComponent";

const DashboardPage = () => {
    const [data, setData] = useState([])
    const [altinorduHavaDurumu, setAltinorduHavaDurumu] = useState(null)
    const [birOncekiYilData, setBirOncekiYilData] = useState([])

    useEffect(() => {
        getData()
        getBirOncekiYilData()
    },[])

    const getData = () => {
        Api.get("/api/Report/GetBosAppDailyReport?RaporTarihi="+dayjs().format("YYYY-MM-DD")).then(res => {
            setData(res.data)
        }).catch(err => {
            console.log(err)
        })
    }

    const getBirOncekiYilData = () => {
        Api.get("/api/Report/GetBosAppDailyReport?RaporTarihi="+dayjs().subtract(1, "year").format("YYYY-MM-DD")).then(res => {
            setBirOncekiYilData(res.data)
        }).catch(err => {
            console.log(err)
        })
    }


    //15 saniye de bir yenilesin
    useEffect(() => {
        const interval = setInterval(() => {
            getData()
            getBirOncekiYilData()
            message.success("Veriler Otomatik Güncellendi")
        }, 15000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        axios.get("https://service.orbel.com.tr/hava-durumu/merkez.php?merkezid=95201").then(res => {
            setAltinorduHavaDurumu(res.data[0])
            console.log(res.data[0])
        }).catch(err => {
            message.error("Hava durumu verisi alınamadı. Lütfen daha sonra tekrar deneyin.");
        });
    }, []);



    return(
        <div className={"p-1"}>
            <Row gutter={[10,10]}>
                <Col span={24}>
                    <Card>
                        <div className={"d-flex justify-content-between"}>
                            <h2>Hoşgeldiniz</h2>
                            <h2>{dayjs().format("DD MMMM YYYY")}</h2>
                        </div>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card title={"Dağ Kızağı Gelirleri"} bodyStyle={{padding:0}}>
                        <Col span={24}>
                            <Badge.Ribbon text="CANLI" color={"red"}>
                                <Card size={"small"}>
                                    <Row gutter={[10,10]}>
                                        <Col span={8}>
                                            <img width={60} src={process.env.PUBLIC_URL + '/assets/images/turnike.png'} alt={"Firma Logosu"}></img>
                                        </Col>

                                        <Col span={16}>
                                            <Row>
                                                <Col span={24}>
                                                    <div style={{fontWeight:"bold", textAlign:"right"}}>
                                                        BUGÜN DAĞ KIZAĞI TOPLAM ZİYARETÇİ SAYISI
                                                    </div>
                                                </Col>
                                                <Col span={24}>
                                                    <div className={"font-color-green"} style={{fontWeight:"bold", textAlign:"right",fontSize:50}}>
                                                        {data?.toplamZiyaretciSayisi}
                                                    </div>
                                                    <div style={{textAlign:"right"}}>
                                                        <span>Bir Önceki Yıl: </span>
                                                        <span style={{fontWeight:"bold"}}>{birOncekiYilData?.toplamZiyaretciSayisi} Adet</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Badge.Ribbon>
                        </Col>

                        <Col span={24}>
                            <Badge.Ribbon text="CANLI" color={"red"}>
                                <Card size={"small"}>
                                    <Row gutter={[10,10]}>
                                        <Col span={8} style={{alignContent:"center"}}>
                                            <img width={75} src={process.env.PUBLIC_URL + '/assets/images/winner.png'} alt={"Firma Logosu"}></img>
                                        </Col>

                                        <Col span={16}>
                                            <Row className={"h-100"}>
                                                <Col span={24}>
                                                    <div style={{fontWeight:"bold", textAlign:"right"}}>
                                                        BUGÜN DAĞ KIZAĞI TOPLAM TUTAR
                                                    </div>
                                                </Col>
                                                <Col span={24}>
                                                    <div className={"font-color-green"} style={{fontWeight:"bold", textAlign:"right",fontSize:30, justifyContent:"center", alignContent:"center"}}>
                                                        {flexCurrency(data?.toplamKazanilanTutar)} TL
                                                    </div>

                                                    <div style={{textAlign:"right"}}>
                                                        <span>Bir Önceki Yıl: </span>
                                                        <span style={{fontWeight:"bold"}}>{flexCurrency(birOncekiYilData?.toplamKazanilanTutar)} TL</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Badge.Ribbon>

                        </Col>

                        <Col span={24}>
                            <Card title={"Dağ Kızağı Satış Tip Tutarları"} size={"small"}>
                                {/*burada hem kredi kartı hemde nakit ne kadar onu belirteceğim*/}
                                <Row>
                                    <Col span={12}>
                                        <Card size={"small"} className={"h-100"}>
                                            <Row>
                                                <Col span={24}>

                                                    <div style={{fontWeight:"bold", textAlign:"center"}}>
                                                        <div>
                                                            <img width={50}
                                                                 src={process.env.PUBLIC_URL + '/assets/images/kasa.png'}
                                                                 alt={""}></img>
                                                        </div>
                                                        <div>
                                                            NAKİT KASA
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col span={24}>
                                                    <div style={{fontWeight:"bold", textAlign:"center"}}>
                                                        {flexCurrency(data?.toplamNakitKazanilanTutar)} TL
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    <Col span={12}>
                                        <Card className={"h-100"}>
                                            <Row>
                                                <Col span={24}>
                                                    <div style={{fontWeight: "bold", textAlign: "center"}}>
                                                        <img width={50}
                                                             src={process.env.PUBLIC_URL + '/assets/images/kredi-karti.png'}
                                                             alt={""}></img>

                                                        <div>
                                                            KREDİ KARTI
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col span={24}>
                                                    <div style={{fontWeight:"bold", textAlign: "center"}}>
                                                        {flexCurrency(data?.toplamKrediKartiKazanilanTutar)} TL
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col span={24}>
                            <Card title={"Dağ Kızağı Tarife Satışları"} size={"small"}>
                                <List
                                    size="small"
                                    bordered
                                    dataSource={data?.toplamTarifeSatislari}
                                    renderItem={(item) => <List.Item>
                                        <Row gutter={[10,10]} style={{width:"100%"}}>
                                            <Col span={8} className={"font-color-green font-weight-bold"}>
                                                {item.tarifeAdi}
                                            </Col>
                                            <Col span={8}>
                                                <div className={"font-weight-bold w-100 text-align-center"}>{item.satisSayisi} ADET</div>
                                            </Col>
                                            <Col span={8}>
                                                <div className={"font-weight-bold w-100 text-align-right"}>{flexCurrency(item.kazanilanTutar)} TL</div>
                                            </Col>
                                        </Row>
                                    </List.Item>}
                                />
                            </Card>


                        </Col>
                    </Card>
                </Col>


                <Col span={24}>
                    <Badge.Ribbon text="CANLI" color={"red"}>
                        <Card title={"Altınordu Hava Durumu"} style={{textAlign:"center"}}>
                            <div style={{textAlign: "center", display:"grid", justifyContent:"center"}}>
                                <div>
                                    <img style={{width:200, textAlign:"center"}} src={process.env.PUBLIC_URL + `/assets/images/hadise/${altinorduHavaDurumu?.hadiseKodu}.svg`} alt={altinorduHavaDurumu?.hadiseKodu}></img>
                                </div>
                                <div style={{fontWeight:"bold", fontSize:60, color:"green"}}>
                                    {altinorduHavaDurumu?.sicaklik}
                                </div>
                                <div>
                                    <span style={{fontWeight:"bold"}}>Nem: </span>
                                    <span>{altinorduHavaDurumu?.nem}%</span>

                                    <span style={{fontWeight:"bold", marginLeft:10}}>Rüzgar: </span>
                                    <span>{altinorduHavaDurumu?.ruzgarHiz.toFixed(2)} km/s</span>


                                    <span style={{fontWeight:"bold", marginLeft:10}}>Deniz Sıcaklığı: </span>
                                    <span>{altinorduHavaDurumu?.denizSicaklik}° </span>

                                    <span style={{fontWeight:"bold", marginLeft:10}}>Basınç: </span>
                                    <span>{altinorduHavaDurumu?.aktuelBasinc} hPa</span>

                                    <span style={{fontWeight:"bold", marginLeft:10}}>Rüzgar Yönü: </span>
                                    <span>{altinorduHavaDurumu?.ruzgarYon}°</span>
                                </div>
                            </div>
                        </Card>
                    </Badge.Ribbon>
                </Col>

                <Col span={24}>
                    <RestaurantComponent></RestaurantComponent>
                </Col>

                <Col span={24}>
                    <HomeFotoKapanComponent></HomeFotoKapanComponent>
                </Col>

                <Col span={24}>
                    <HomeAracGecisComponent></HomeAracGecisComponent>
                </Col>

                <Col span={24}>
                    <GelirToplamComponent/>
                </Col>

                <Col span={24} style={{marginBottom:50}}>

                </Col>
            </Row>
        </div>
    )
}

export default DashboardPage
